import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungAachen() {
  return (
    <CityPageTemplate
      city="Aachen"
      slug="aachen"
      intro="Die Kaiserstadt Aachen mit ihrer starken Hochschullandschaft – ob Student oder Berufseinsteiger, wir beraten Dich."
      description="Unabhängige & digitale Finanzberatung für Aachen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
